import React from 'react';

import { Text } from 'xpi-black-ui/Base/Typography';
import SearchBar from 'xpi-black-ui/Common/SearchBar';
import CloseButton from 'xpi-black-ui/Base/CloseButton';

import { FiltersContainer, TitleContainer, HeaderContainer, Tag } from './styles';

const Header = ({ onSearch, onCloseDialog }) => (
  <Tag>
    <TitleContainer>
      <Text larger>Envio de Proposta ao Cliente</Text>
      <CloseButton onClick={onCloseDialog} />
    </TitleContainer>
    <HeaderContainer>
      <Text bigger>Lista de Clientes</Text>
      <FiltersContainer>
        <SearchBar
          debounce={1000}
          minLength={-1}
          onKeyUp={onSearch}
          placeholder="Pesquisar cliente"
        />
      </FiltersContainer>
    </HeaderContainer>
  </Tag>
);

export default Header;
